import { Component, linkedSignal, signal, ChangeDetectionStrategy } from '@angular/core';

import { Modal, ResolvableModal} from '@softline/ui-core';
import { MengenEingabeComponent } from '@softline/application';

import { IconComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-etiketten-drucken-dialog',
  imports: [MengenEingabeComponent,
    IconComponent,
    TranslatePipe],
  templateUrl: './etiketten-drucken-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./etiketten-drucken-dialog.component.css'] })
export class EtikettenDruckenDialogComponent
  extends ResolvableModal<number | 'NO'>
  implements Modal<number | 'NO'>
{
  public anzahlEtiketten = linkedSignal(() => this.minAmount());

  readonly minAmount = signal(0);

  get anzahlPaletteMin(): number {
    return this.minAmount();
  }
  set anzahlPaletteMin(value: number) {
    this.minAmount.set(value);
  }

  _close?: (result: number | 'NO') => void;

  registerCloseHandler(handler: (result: number | 'NO') => void): void {
    this._close = handler;
  }

  close(result: number | 'NO') {
    if (!this._close) {
      this.resolve(result);
    } else {
      this._close(result);
    }
  }
}
